import React from 'react'
import PropTypes from 'prop-types'

import * as firebase from 'firebase'
import Snackbar from 'material-ui/Snackbar'

import AppHeader from './AppHeader'
import ModulesUtils from './infra/ModulesUtils'
import MessagingController from './infra/messaging/MessagingController'
import IntercomUtils from './infra/IntercomUtils'

export default class App extends React.Component {

  static propTypes = {
    children: PropTypes.object.isRequired,
    routes: PropTypes.array.isRequired,
    member: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.userId = firebase.auth().currentUser.uid
    this.state = {
      snackbarMessage: ''
    }
    ModulesUtils.showSnackbar = (message) => {
      this.setState({ snackbarMessage: message })
    }
    this.fcmController = new MessagingController(this.userId)
  }

  componentDidMount() {
    this.fcmController.initialize()
    IntercomUtils.initIntercom(this.props.member)
  }

  render() {
    return (
      <div style={styles.surface}>
        <AppHeader member={this.props.member} title={this.props.routes[2].path} />
        <div style={styles.content}>
          { this.props.children }
        </div>
        <Snackbar
          open={this.state.snackbarMessage !== ''}
          message={this.state.snackbarMessage}
          autoHideDuration={3000}
          onRequestClose={() => { this.setState({ snackbarMessage: '' }) }} />
      </div>
    )
  }
}

const styles = {
  surface: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  content: {
    display: 'flex',
    flex: 1,
    height: 'calc(100% - 64px)'
  }
}



// WEBPACK FOOTER //
// ./src/App.js